export default function KiToolsScreen() {
  return (
    <div className="dx-card" style={{ textAlign: "center", padding: "60px 20px" }}>
      <h2>KI-Tools</h2>
      <p className="dx-muted">In Vorbereitung.</p>
    </div>
  );
}
